<template>
  <v-checkbox
    dense
    hide-details
    class="ma-0 label"
    :input-value="checked"
    :id="id"
    :data-testid="testId"
    :label="name"
    @click.native="check"
  />
</template>

<script>
export default {
  name: 'Checkbox',

  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
    },
    testId: {
      type: String,
      required: true,
    },
  },

  methods: {
    check() {
      this.$emit('onChecked', this.id, !this.checked)
    },
  },
}
</script>
